import { useDispatch } from 'react-redux';
import useShortCode from './useShortCode';
import useUser from './useUser';
import usePush from './usePush';
import { useCacheActions } from './useFetch';
import SettingsService from '../services/settings-service';
import AccountService from '../services/account-service';
import { setUser } from '../app/login/duck/actions/login';
import { pendo } from '../util/logging';

function useCashFlowForecastTrial() {
  const shortCode = useShortCode();
  const { token } = useUser();
  const dispatch = useDispatch();
  const { invalidateDomain } = useCacheActions();

  const { execute, loading, error } = usePush(
    () => SettingsService.startCashFlowForecastTrial(shortCode),
    {
      successToast: 'Your 3-day free trial has started!',
      errorToast: 'Failed to start trial. Please try again.',
    },
  );

  const { execute: executeRequest, loading: requesting } = usePush(
    () => SettingsService.requestCashFlowForecastAddon(shortCode),
    {
      successToast: 'Request sent! The account subscriber has been notified.',
      errorToast: 'Failed to send request. Please try again.',
    },
  );

  const { execute: executeGetCurrentUser } = usePush(AccountService.getCurrentUser, {
    suspense: false,
  });

  const startTrial = async () => {
    const [err] = await execute();
    if (!err) {
      pendo.track('trial_activated', {
        product: 'cash_flow_forecast',
        shortCode,
      });
      invalidateDomain('organisation');
      invalidateDomain('user');
      const [userErr, updatedUser] = await executeGetCurrentUser();
      if (!userErr && updatedUser) {
        dispatch(setUser({ ...updatedUser, token }));
      }
    }
  };

  const requestAddon = async () => {
    await executeRequest();
  };

  return {
    loading,
    error,
    startTrial,
    requestAddon,
    requesting,
  };
}

export default useCashFlowForecastTrial;
